var _style, _filter, _image, _mask, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _g, _image2, _mask2, _clipPath6, _use, _use2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 70,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n            @font-face {\n              font-family: Monorale;\n              font-weight: 400;\n              font-style: normal;\n              src: url('/fonts/Monorale-Regular.woff') format('woff');\n              font-display: fallback;\n            }\n            @font-face {\n                font-family: Monorale;\n                font-weight: 500;\n                font-style: normal;\n                src: url('/fonts/Monorale-Medium.woff') format('woff');\n                font-display: fallback;\n            }\n            @font-face {\n                font-family: Monorale;\n                font-weight: 700;\n                font-style: normal;\n                src: url('/fonts/Monorale-Bold.woff') format('woff');\n                font-display: fallback;\n            }\n        ")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 0.99716,
    y2: 0.99716,
    gradientTransform: "matrix(60,0,0,60,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(49.019608%,72.156863%,85.882353%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(36.078431%,62.745098%,81.960784%)",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image19",
    width: 60,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAABmJLR0QA/wD/AP+gvaeTAAAB30lEQVRoge3bMWgTYRTA8f/7PAKWqIsgje3YStEiolMX6eZk06lCwEUwpSBYnDsJ4uAiKE4dtAg6lJpQShyla50iFIVOJQ0NTiJR4nmfQzwIEXGQ3Gee7zddji/w/mS4DPeEPv7g7ggny9eR2SJy8RxUTsHnqP/cvykfw9wh/u07/M4GHx+sSWGl3XtCej/4eGoeLjyCl4VsBx2UUgNaSxLVqukdl174zr1l2FvXEwvw/DS82fCdh7fTOwLpL7u3Dt/l918eZrkELs9LVKuK3792lNGRD/B0LPRYg7VwQGtqQnyntYgbfRJ6nEwklB0yWww9R2bkUtEh56dDz5EZOTstPj7xbXies38rH4uPj/jQY2TJ/fmILhasnQVrZ8HaWbB2FqydBWtnwdpZsHYWrJ0Fa2fB2lmwdhasnQVrZ8HaWbB2FqydBWtnwdpZsHau+9r8/yIfO5g7DD1GdhaaDl+vhx4jM3637vCvK6HnyIyvv/q5AnD8PayOh55nsEoNWhOTTsZffIHdW91FCK1yCbAohZW2A5Bou0Jy/47O6FxCsros0bNN+GVR68pVKDzWs+FyYx++LqWx0PfHQ6JalWZ7koQyfmaru9k1TM/pfAylBn5mi+TYTZqfzvTGAvwABSmAnDFoN3QAAAAASUVORK5CYII="
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image19"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial0",
    gradientUnits: "userSpaceOnUse",
    cx: 0.06224,
    cy: 1.37133,
    fx: 0.06224,
    fy: 1.37133,
    r: 3.31925,
    gradientTransform: "matrix(53.143648,0,0,53.144531,-14.782187,6.855469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(50.196078%,100%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0503,
    style: {
      stopColor: "rgb(48.627451%,97.254902%,99.215686%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7034,
    style: {
      stopColor: "rgb(29.803922%,63.137255%,92.156863%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(22.352941%,49.803922%,89.019608%)",
      stopOpacity: 1
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface6",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial0)"
    },
    d: "M -17.144531 33.429688 L 28.667969 6.855469 L 73.332031 32.765625 C 73.570312 32.902344 73.714844 33.15625 73.714844 33.429688 C 73.714844 33.703125 73.570312 33.953125 73.332031 34.089844 L 28.667969 60 Z M -17.144531 33.429688 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.788235,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial1",
    gradientUnits: "userSpaceOnUse",
    cx: -0.22935,
    cy: -1.06478,
    fx: -0.22935,
    fy: -1.06478,
    r: 3.91259,
    gradientTransform: "matrix(53.143648,0,0,53.140625,-25.776172,-18.855469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(50.196078%,100%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0503,
    style: {
      stopColor: "rgb(48.627451%,97.254902%,99.215686%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7034,
    style: {
      stopColor: "rgb(29.803922%,63.137255%,92.156863%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(22.352941%,49.803922%,89.019608%)",
      stopOpacity: 1
    }
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial1)"
    },
    d: "M -17.144531 7.714844 L 28.667969 -18.855469 L 73.332031 7.050781 C 73.570312 7.1875 73.714844 7.441406 73.714844 7.714844 C 73.714844 7.988281 73.570312 8.238281 73.332031 8.375 L 28.667969 34.285156 Z M -17.144531 7.714844 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.94902,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial2",
    gradientUnits: "userSpaceOnUse",
    cx: -0.65138,
    cy: 1.46738,
    fx: -0.65138,
    fy: 1.46738,
    r: 5.18568,
    gradientTransform: "matrix(44.574219,0,0,44.571402,-15.429688,29.828125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(50.196078%,100%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0503,
    style: {
      stopColor: "rgb(48.627451%,97.254902%,99.215686%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7034,
    style: {
      stopColor: "rgb(29.803922%,63.137255%,92.156863%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(22.352941%,49.803922%,89.019608%)",
      stopOpacity: 1
    }
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface12",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial2)"
    },
    d: "M -15.429688 34.855469 L -15.429688 -15.429688 L 29.144531 9.714844 L 29.144531 60 Z M -15.429688 34.855469 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.901961,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial3",
    gradientUnits: "userSpaceOnUse",
    cx: 0.06224,
    cy: 1.37135,
    fx: 0.06224,
    fy: 1.37135,
    r: 3.31925,
    gradientTransform: "matrix(53.143648,0,0,53.144531,-14.782187,-41.144531)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(50.196078%,100%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0503,
    style: {
      stopColor: "rgb(48.627451%,97.254902%,99.215686%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7034,
    style: {
      stopColor: "rgb(29.803922%,63.137255%,92.156863%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(22.352941%,49.803922%,89.019608%)",
      stopOpacity: 1
    }
  })), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface15",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial3)"
    },
    d: "M -17.144531 -14.570312 L 28.667969 -41.144531 L 73.332031 -15.234375 C 73.570312 -15.097656 73.714844 -14.84375 73.714844 -14.570312 C 73.714844 -14.296875 73.570312 -14.046875 73.332031 -13.910156 L 28.667969 12 Z M -17.144531 -14.570312 "
  })), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface18",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface6",
    mask: "url(#mask1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface9",
    mask: "url(#mask2)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface12",
    mask: "url(#mask3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface15",
    mask: "url(#mask4)"
  }))), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "image25",
    width: 60,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAABmJLR0QA/wD/AP+gvaeTAAAAiElEQVRoge3PvQnCUACF0Ty1cAXBSsEJHDDgiulSxiEEn8QREgjx53JOfYv7NQ0AAAA0Zc5ofNxOax9ZrGuHcn09p2bzgut2XP5oZfV+KftDPzXbfOLLLxGcTnA6wekEpxOcTnA6wekEpxOcTnA6wekEpxOcbjdrVdvzyj+W647Dty8AAADwN95mMhCvx2QX1AAAAABJRU5ErkJggg=="
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image25"
  })))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface24",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 38.46875 15.855469 C 40.5 15.855469 42.335938 17.046875 43.136719 18.820312 L 43.257812 19.121094 L 45.839844 24.875 C 48.164062 25.078125 49.988281 26.949219 50.132812 29.277344 L 50.144531 29.570312 L 50.144531 36 C 50.144531 37.019531 49.636719 37.921875 48.859375 38.460938 L 48.855469 40.285156 C 48.859375 42.367188 47.210938 44.078125 45.132812 44.148438 C 43.050781 44.21875 41.289062 42.625 41.152344 40.550781 L 41.144531 40.285156 L 41.144531 39 L 18 39 L 18 40.285156 C 18.003906 42.367188 16.355469 44.078125 14.273438 44.148438 C 12.195312 44.21875 10.433594 42.625 10.292969 40.550781 L 10.285156 40.285156 L 10.285156 38.460938 C 9.570312 37.964844 9.085938 37.164062 9.011719 36.246094 L 9 36 L 9 29.570312 C 9 27.125 10.867188 25.085938 13.304688 24.875 L 15.855469 19.195312 C 16.5625 17.300781 18.316406 16 20.335938 15.871094 L 20.671875 15.855469 Z M 15.429688 39 L 12.855469 39 L 12.855469 40.285156 C 12.855469 40.960938 13.382812 41.523438 14.054688 41.566406 C 14.730469 41.613281 15.324219 41.128906 15.417969 40.460938 L 15.429688 40.285156 Z M 46.285156 39 L 43.714844 39 L 43.714844 40.285156 C 43.714844 40.960938 44.238281 41.523438 44.914062 41.566406 C 45.585938 41.613281 46.179688 41.128906 46.273438 40.460938 L 46.285156 40.285156 Z M 45.429688 27.429688 L 13.714844 27.429688 C 12.617188 27.429688 11.695312 28.257812 11.582031 29.351562 L 11.570312 29.570312 L 11.570312 36 C 11.570312 36.203125 11.710938 36.375 11.910156 36.417969 L 12 36.429688 L 47.144531 36.429688 L 47.234375 36.417969 C 47.394531 36.382812 47.523438 36.257812 47.558594 36.097656 L 47.570312 36 L 47.570312 29.570312 C 47.570312 28.386719 46.613281 27.429688 45.429688 27.429688 Z M 43.070312 30 C 44.066406 30 44.882812 30.753906 44.988281 31.71875 L 45 31.929688 C 45 32.921875 44.246094 33.742188 43.28125 33.84375 L 43.070312 33.855469 C 42.007812 33.855469 41.144531 32.992188 41.144531 31.929688 C 41.144531 30.863281 42.007812 30 43.070312 30 Z M 16.070312 30 C 17.066406 30 17.882812 30.753906 17.988281 31.71875 L 18 31.929688 C 18 32.992188 17.136719 33.855469 16.070312 33.855469 C 15.007812 33.855469 14.144531 32.992188 14.144531 31.929688 C 14.144531 30.863281 15.007812 30 16.070312 30 Z M 38.46875 18.429688 L 20.671875 18.429688 C 19.679688 18.429688 18.785156 18.996094 18.335938 19.929688 L 18.230469 20.171875 L 16.125 24.855469 L 43.011719 24.855469 L 40.878906 20.097656 C 40.535156 19.175781 39.691406 18.53125 38.714844 18.441406 Z M 38.46875 18.429688 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "url(#linear0)"
    },
    d: "M 8.570312 0 L 51.429688 0 C 56.164062 0 60 3.835938 60 8.570312 L 60 51.429688 C 60 56.164062 56.164062 60 51.429688 60 L 8.570312 60 C 3.835938 60 0 56.164062 0 51.429688 L 0 8.570312 C 0 3.835938 3.835938 0 8.570312 0 Z M 8.570312 0 "
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface18",
    mask: "url(#mask0)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface24",
    mask: "url(#mask5)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Monorale",
    fontSize: 20,
    fontWeight: 300,
    letterSpacing: 1.333,
    transform: "translate(52 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 25,
    y: 20
  }, "SCORER Cloud")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Monorale",
    fontSize: 26,
    fontWeight: 600,
    letterSpacing: 0.833,
    transform: "translate(52 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 25,
    y: 55
  }, "TRAFFIC COUNTER")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginScreen);
export default __webpack_public_path__ + "static/media/login-screen.42cefdf2.svg";
export { ForwardRef as ReactComponent };